/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import { client, withUnwrap } from '../.kubb/client'
import type { AuthRefreshOptions, AuthRefreshResponses } from '../models/AuthRefresh'
import { authRefreshResponseSchema } from '../schemas/authRefreshSchema'

/**
 * @summary Rotate the refresh cookie → a new access+refresh pair, with roles/org re-read fresh from the DB.
 * {@link /api/v4/auth/refresh}
 */
export function authRefresh<ThrowOnError extends boolean = true>(
  options: Options<AuthRefreshOptions, ThrowOnError> = {}
): Unwrappable<RequestResult<AuthRefreshResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'POST',
      url: '/api/v4/auth/refresh',
      validator: { response: authRefreshResponseSchema },
      ...config,
    }) as Promise<RequestResult<AuthRefreshResponses, ThrowOnError>>
  )
}
